export function getErrorMessage(error: unknown): string {
    if (error instanceof Error) {
        return error.message;
    }
    return String(error);
}

export function getError(error: unknown): Error {
    if (error instanceof Error) {
        return error;
    }
    return new Error(String(error), { cause: error });
}
